export const LOGIN_ERRORS = {
  BAD_REQUEST: 'VERIFICATION_CODE_PAGE_ERROR_TEXT',
} as const;
export const LOGIN_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  MFA: 'MFA_CHALLENGE',
  PASSWORD_EXPIRED: 'PASSWORD_EXPIRED',
};
